import axios from 'axios';

// Get API base URL from environment variable or use relative URL
// In production: uses relative URL '/api' (Caddy proxies to backend)
// In development: can use REACT_APP_API_URL if set, otherwise uses relative URL
// The relative URL works because:
// - Development: react-scripts proxy (see package.json) handles /api/* requests
// - Production: Caddy reverse proxy handles /api/* requests
const getBaseURL = () => {
  // If REACT_APP_API_URL is set, use it (useful for different environments)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // Otherwise use relative URL (works with proxy/Caddy)
  return '/api';
};

const api = axios.create({
  baseURL: getBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;

